import { fmtPct, fmtR$, marginBg, marginColor } from "../lib/formato";

// As 5 colunas de números, iguais para produto e categoria. `legenda` é o texto
// miúdo embaixo do valor ("30 dias", "média/item") — sem ela é linha de produto.

function Dupla({ valor, abaixo, cls = "" }) {
  return (
    <td className="py-2 px-2 text-right">
      <div className="flex flex-col items-end leading-tight">
        <span className={`font-mono font-semibold ${cls}`}>{valor}</span>
        {abaixo ? <span className="font-mono text-[10px] text-muted-foreground tabular-nums">{abaixo}</span> : null}
      </div>
    </td>
  );
}

export function BarraMargem({ margin }) {
  return (
    <td className="py-2.5 px-2 text-right">
      <div className="inline-flex items-center gap-2">
        <div className="w-16 h-2 bg-muted rounded-full overflow-hidden">
          <div className={`h-full rounded-full ${marginBg(margin)}`} style={{ width: `${Math.min(Math.max(margin, 0), 100)}%` }} />
        </div>
        <span className={`font-mono font-bold text-xs min-w-[50px] ${marginColor(margin)}`}>{fmtPct(margin)}</span>
      </div>
    </td>
  );
}

function CelulaVendas({ linha }) {
  return (
    <td className="py-2 px-2 pr-5 text-right">
      {linha.soldRevenue > 0 ? (
        <div className="flex flex-col items-end leading-tight">
          <span className="font-mono font-bold text-xs text-foreground">{fmtPct(linha.salesShare)}</span>
          <span className="font-mono text-[10px] text-muted-foreground tabular-nums">{fmtR$(linha.soldRevenue)}</span>
        </div>
      ) : (
        <span className="text-[10px] text-muted-foreground/50">—</span>
      )}
    </td>
  );
}

export default function CelulasValores({ linha, legenda }) {
  if (linha.semDados) {
    return (
      <>
        <td colSpan={4} className="py-2.5 px-2 text-right text-[11px] text-muted-foreground">
          Nenhum produto com ficha técnica — cadastre a ficha para ver o CMV
        </td>
        <CelulaVendas linha={linha} />
      </>
    );
  }
  const lucroCls = linha.lucro >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400";
  const cmvAbaixo = linha.venda > 0 ? `${fmtPct(linha.cmvPct)}${legenda ? ` · ${legenda}` : ""}` : "—";
  return (
    <>
      <Dupla valor={fmtR$(linha.cmv)} abaixo={cmvAbaixo} cls="text-red-600 dark:text-red-400" />
      <Dupla valor={fmtR$(linha.venda)} abaixo={legenda} />
      <Dupla valor={fmtR$(linha.lucro)} abaixo={legenda} cls={lucroCls} />
      <BarraMargem margin={linha.margin} />
      <CelulaVendas linha={linha} />
    </>
  );
}
